exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feature-box-wrapper{padding-bottom:10px;background-color:#fff}.feature-box-video iframe{width:100%;max-width:390px}", ""]);

// exports
